var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{class:("message " + _vm.level)},[(_vm.level === 'error')?_c('span'):(_vm.level === 'warning')?_c('span'):(_vm.level === 'info')?_c('span'):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.message))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }